import Transform from '@ember-data/serializer/transform';
// For when you have a generic 'value' field which may require
// deserializing an object, but not always. Such as a key, value store

export default class JsonOrValue extends Transform {
  deserialize(serialized) {
    try {
      return JSON.parse(serialized);
    } catch {
      return serialized;
    }
  }
  serialize(deserialized) {
    if (typeof deserialized === 'object' && deserialized !== null) {
      return JSON.stringify(deserialized);
    }
    return deserialized;
  }
}